
import KeenSlider from "keen-slider/keen-slider.es.js";

export default function initSlider() {
	const sliders = document.querySelectorAll('.make-slider');
	
	sliders.forEach(sliderElement => {
		let slider;
		let needsSlider = false;
		
		// Add overflow hidden to prevent horizontal scroll
		const container = sliderElement.parentElement;
		container.style.overflow = 'hidden';
		
		function checkSliderNeed() {
			const containerWidth = container.offsetWidth;
			const slides = sliderElement.querySelectorAll('.keen-slider__slide');
			let totalWidth = 0;
			
			slides.forEach(slide => {
				totalWidth += slide.offsetWidth + 24; // Add gap
			});
			
			return totalWidth > containerWidth;
		}
		
		function initSliderInstance() {
			if (slider) {
				slider.destroy();
			}
			
			needsSlider = checkSliderNeed();
			
			if (needsSlider) {
				// Allow slider to use the full container width
				sliderElement.style.overflow = 'visible';
				
				slider = new KeenSlider(sliderElement, {
					slides: {
						perView: "auto",
						spacing: 24,
					},
					breakpoints: {
						"(max-width: 768px)": {
							slides: {
								perView: 1.2,
								spacing: 8,
							}
						}
					}
				});
				
				// Show controls
				const controls = sliderElement.parentElement.querySelector('.slider-controls');
				if (controls) {
					controls.style.display = 'flex';
				}
				
				// Bind control events
				const prevBtn = sliderElement.parentElement.querySelector('.slider-prev');
				const nextBtn = sliderElement.parentElement.querySelector('.slider-next');
				
				if (prevBtn) {
					prevBtn.onclick = () => slider.prev();
				}
				
				if (nextBtn) {
					nextBtn.onclick = () => slider.next();
				}
			} else {
				// Hide controls if not needed
				const controls = sliderElement.parentElement.querySelector('.slider-controls');
				if (controls) {
					controls.style.display = 'none';
				}
			}
		}
		
		// Initialize
		initSliderInstance();
		
		// Reinitialize on window resize
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(initSliderInstance, 250);
		});
	});
}
